import { ProductTypeEnum } from 'src/app/product-capture/model/enums/product-capture.enums';
import {
  PAYOFF_CALLABILITY_CALLABILITY,
  PAYOFF_CALLABILITY_CALL_EVENT_TYPE,
  PAYOFF_COUPON,
  PAYOFF_COUPON_TYPE,
  PAYOFF_PARTICIPATION_BASE_TYPE,
  PAYOFF_PARTICIPATION_DOWNSIDE_TYPE,
  PAYOFF_PARTICIPATION_FLOOR_STRIKE,
  PAYOFF_PARTICIPATION_STRIKE,
  PAYOFF_PARTICIPATION_UPSIDE_TYPE,
  SUMMARY_FREQUENCY,
  SUMMARY_PERFORMANCE_TYPE,
  SUMMARY_REFERENCE_ENTITIES,
  SUMMARY_SETTLEMENT_TYPE,
  SUMMARY_UNDERLYING_ASSETS_GROUP,
  PAYOFF_PARTICIPATION_DOWNSIDE_LEVERAGE,
} from '../../mockups/consts/product-capture-field-selectors.consts';
import { DEFAULT_AND_HIDE_CAPITAL_BASE_VALUES } from './cln.settings';

export const SUPERTRACKER_SETTINGS = {
  id: ProductTypeEnum.SUPERTRACKER,
  label: 'Supertracker',
  effects: [
    {
      formControlNames: [
        SUMMARY_REFERENCE_ENTITIES,
        PAYOFF_COUPON,
        PAYOFF_CALLABILITY_CALLABILITY,
      ],
      hidden: true,
    },
    {
      formControlNames: [
        PAYOFF_PARTICIPATION_BASE_TYPE,
        PAYOFF_CALLABILITY_CALL_EVENT_TYPE,
        PAYOFF_COUPON_TYPE,
      ],
      selectValues: ['NONE'],
      readOnly: false,
      hidden: true,
    },
    {
      formControlNames: [PAYOFF_PARTICIPATION_UPSIDE_TYPE],
      selectValues: ['CALL'],
      options: ['CALL', 'KNOCK_OUT_CALL', 'DIGITAL'],
      hidden: false,
    },
    {
      formControlNames: [PAYOFF_PARTICIPATION_DOWNSIDE_TYPE],
      selectValues: ['PUT'],
      hidden: false,
    },
    ...DEFAULT_AND_HIDE_CAPITAL_BASE_VALUES,
    {
      formControlNames: [
        SUMMARY_UNDERLYING_ASSETS_GROUP,
        PAYOFF_PARTICIPATION_FLOOR_STRIKE,
      ],
      hidden: false,
    },
    {
      formControlNames: [SUMMARY_FREQUENCY],
      selectValues: ['AT_MATURITY'],
      readOnly: true,
    },
    {
      formControlNames: [SUMMARY_PERFORMANCE_TYPE, SUMMARY_SETTLEMENT_TYPE],
      readOnly: false,
    },
    {
      formControlNames: [PAYOFF_PARTICIPATION_DOWNSIDE_LEVERAGE],
      selectValues: [
        {
          minValue: null,
          maxValue: null,
          value: null,
          indicativeValue: null,
        },
      ],
      readOnly: false,
    },
    {
      formControlNames: [PAYOFF_PARTICIPATION_STRIKE],
      selectValues: [
        {
          minValue: null,
          maxValue: null,
          value: null,
          indicativeValue: null,
        },
      ],
    },
  ],
};
